import React, { lazy } from "react";
import { docLazyFn } from '@/router/untilFn'

// 沙盒-导航栏
import SandBox from '@/components/SandBox'


import RecordAdjustment from '@/views/RecordAdjustment/GLTrans/index'
import VoidCheck from '@/views/RecordAdjustment/VoidCheck/index'
import JournalEntry from '@/views/RecordAdjustment/JournalEntry/index'
import DebitExpense from '@/views/RecordAdjustment/DebitExpense/index'
const recordAdjustmentRouter = [
  {
    path: "/RecordAdjustment",
    element: <SandBox />,
    children: [
      {
        path: "index",
        element: docLazyFn(<RecordAdjustment />),
      },
       {
        path: "VoidCheck",
        element: docLazyFn(<VoidCheck />),
      },{
        path: "JournalEntry",
        element: docLazyFn(<JournalEntry />),
      },
      {
        path: "DebitExpense",
        element: docLazyFn(<DebitExpense />),
      }
    ],
  }
];

export default recordAdjustmentRouter;
